import { useQuery } from "@tanstack/react-query";
import { supabase } from "../lib/supabase";

// Macro categories per cui ha senso disegnare un'area territoriale.
const AREA_MACRO_CATEGORIES = new Set(["DMO", "Organizzazioni Turistiche", "Destinazione turistica"]);

export function isDmoMacroCategory(macro: string | null | undefined): boolean {
  return !!macro && AREA_MACRO_CATEGORIES.has(macro);
}

// GeoJSON geometry restituito da get_dmo_area().
type DmoAreaGeometry =
  | { type: "MultiPolygon"; coordinates: number[][][][] }
  | { type: "Polygon"; coordinates: number[][][] }
  | null;

async function fetchDmoArea(dmoName: string): Promise<DmoAreaGeometry> {
  const { data, error } = await supabase.rpc("get_dmo_area", {
    p_dmo_name: dmoName,
  });
  if (error) throw error;
  return (data as DmoAreaGeometry) ?? null;
}

/**
 * Recupera la geometria unione (MultiPolygon GeoJSON) dell'area
 * coperta dalla DMO/Organizzazione Turistica/Destinazione.
 */
export function useDmoArea(dmoName: string | null | undefined, enabled = true) {
  return useQuery({
    queryKey: ["dmo-area", dmoName],
    queryFn: () => fetchDmoArea(dmoName!),
    enabled: enabled && !!dmoName,
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60 * 4,
  });
}
